var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudentUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1098_3843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4188 16.5247C20.4486 16.5247 23.7154 13.2579 23.7154 9.22817C23.7154 5.19841 20.4486 1.93164 16.4188 1.93164C12.3891 1.93164 9.12231 5.19841 9.12231 9.22817C9.12231 13.2579 12.3891 16.5247 16.4188 16.5247Z",
    fill: "#EE4E56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4187 18.957C10.3768 18.9638 5.4806 23.86 5.47388 29.9018C5.47388 30.5734 6.01832 31.1179 6.68995 31.1179H26.1473C26.819 31.1179 27.3634 30.5734 27.3634 29.9018C27.3567 23.86 22.4605 18.9637 16.4187 18.957Z",
    fill: "#EE4E56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1098_3843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 31,
    fill: "white",
    transform: "translate(0.418701 0.53125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentUserIcon);
export default __webpack_public_path__ + "static/media/student-user-icon.34d34011ee01cdd5481343ec4f4892df.svg";
export { ForwardRef as ReactComponent };